import React from 'react'
import ErrorPage from "app/pages/ErrorPage"
import HomePage from 'app/pages/HomePage'
import { Routes, Route } from "react-router"
import ContactPage from "app/pages/ContactPage"
import TeamPage from "app/pages/TeamPage"
import BlogPage from "app/pages/BlogPage"
import OurStoryPage from "app/pages/OurStoryPage"
import FaqsPage from "app/pages/FaqsPage"
import PrivacyPage from "app/pages/PrivacyPage"
import DisclaimerPage from "app/pages/DisclaimerPage"
import ArticlePage from "app/pages/ArticlePage"
import AppointmentPage from "app/pages/AppointmentPage"
import GeneralMedicinePage from "app/pages/GeneralMedicinePage"
import PediatricsPage from "app/pages/PediatricsPage"
import WomensHealthPage from "app/pages/WomensHealthPage"
import DermatologyPage from "app/pages/DermatologyPage"

export default function RoutesContainer() {

  return (
    <div className="routes-container">
      <Routes>
        <Route index element={<HomePage />} />
        <Route path="/make-an-appointment" element={<AppointmentPage />} />
        <Route path="/services/general-medicine" element={<GeneralMedicinePage />} />
        <Route path="/services/pediatrics" element={<PediatricsPage />} />
        <Route path="/services/womens-health" element={<WomensHealthPage />} />
        <Route path="/services/dermatology" element={<DermatologyPage />} />
        <Route path="/team" element={<TeamPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:articleID" element={<ArticlePage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/about/our-story" element={<OurStoryPage />} />
        <Route path="/about/faqs" element={<FaqsPage />} />
        <Route path="/privacy-policy" element={<PrivacyPage />} />
        <Route path="/disclaimer" element={<DisclaimerPage />} />
        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </div>
  )
}
